import { render, staticRenderFns } from "./firm-policy-detail.vue?vue&type=template&id=492e7b72&scoped=true&"
import script from "./firm-policy-detail.vue?vue&type=script&lang=js&"
export * from "./firm-policy-detail.vue?vue&type=script&lang=js&"
import style0 from "./firm-policy-detail.vue?vue&type=style&index=0&id=492e7b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e7b72",
  null
  
)

export default component.exports